// This wraps the actual dialog and is the reliable element to look for,
// since using multiple dialogs will still always add/remove this.
const VUETIFY_DIALOG_CONTENT_ACTIVE_CLASS = '.v-dialog__content--active';

// This element hosts the v-dialog Vue component instance as .__vue__
const VUETIFY_DIALOG_ACTIVE_CLASS = '.v-dialog--active';

export function getCurrentVuetifyDialog() {
  const el = document.querySelector(
    VUETIFY_DIALOG_CONTENT_ACTIVE_CLASS + ' ' + VUETIFY_DIALOG_ACTIVE_CLASS
  );
  if (!el) {
    return null;
  }

  const vm = el.__vue__;
  if (!vm) {
    return null;
  }

  const dialogComponent = vm.$options._renderChildren[0];
  return dialogComponent;
}

/**
 * Tries to find and close any current active Vuetify dialog.
 *
 * Returns:
 *
 *   found (Boolean): Whether the dialog was found. This doesn't
 *     necessarily mean it was closed, as e.g. the 'persistent' prop may
 *     have prevented that.
 *
 */
export function closeCurrentVuetifyDialog() {
  const dialogComponent = getCurrentVuetifyDialog();
  if (!dialogComponent) {
    return false;
  }

  // HACK: This is a private API and in most cases won't trigger
  //   eventual close-handler logic which the actual component otherwise
  //   may implement e.g. in a custom close() method.
  try {
    const dialogContext = dialogComponent.context;
    const persistent = ['true', true, ''].includes(
      dialogContext.$options.propsData.persistent
    );
    if (persistent) {
      dialogContext.animateClick();
      return true;
    }

    dialogContext.isBooted = false;
    dialogContext.isActive = false;
  } catch (error) {
    console.log('[ERROR] Could not close current Vuetify dialog: ' + error);
    return false;
  }

  return true;
}



// WEBPACK FOOTER //
// ./src/mixins/currentDialog.js